/**
 * @module builder
 */

import type { UpdateableAreaSubstrate } from '../../../area-substrates'

// Mistmatching on types when performing bulk material update on area substrates.
// This function just makes those adjustments so we can update the UpdateableAreaSubstrate we have just made
export function adjustAreaSubstrate(areaSubstrate: UpdateableAreaSubstrate): UpdateableAreaSubstrate {
  const adjustedAreaSubstrate = {
    ...areaSubstrate,
    rateValue: { default: areaSubstrate.rate_value, useCustom: false, custom: 0 },
    section: areaSubstrate.rate.section,
    height: {
      useCustom: areaSubstrate.override_height,
      custom: areaSubstrate.override_height ? areaSubstrate.height : 0,
      default: areaSubstrate.height ?? null
    },
    hours: {
      useCustom: areaSubstrate.override_hours,
      custom: areaSubstrate.override_hours ? areaSubstrate.override_hours_value : 0,
      default: areaSubstrate.hours
    },
    length: {
      useCustom: areaSubstrate.override_length,
      custom: areaSubstrate.override_length ? areaSubstrate.length : '',
      default: ''
    },
    price: {
      useCustom: areaSubstrate.override_price,
      custom: areaSubstrate.override_price ? areaSubstrate.override_price_value : 0,
      default: areaSubstrate.price
    },
    rate: {
      ...areaSubstrate.rate,
      quoteType: areaSubstrate.rate?.int_ext,
      rateSection: areaSubstrate?.rate.section,
      custom: areaSubstrate.rate?.use_custom,
      rateType: areaSubstrate.rate?.rate_type,
      calculationType: areaSubstrate.rate?.calculation_type,
      possibleApplications: areaSubstrate.rate?.possible_applications,
      defaultApplications: areaSubstrate.rate?.default_applications,
      reportText: areaSubstrate.rate?.report_text,
      areaReportText: areaSubstrate.rate?.area_report_text
    },
    clientLabel: areaSubstrate.client_label,
    name: areaSubstrate.rate.label
  }

  return adjustedAreaSubstrate
}
